import ContactPage from './Page/ContactPage';

export const Pages = { ContactPage };
